/* Divotory interface behaviour. Works without the motion layer; every feature degrades to plain HTML. */
(() => {
  const root = document.documentElement;
  const ready = (fn) => (document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn, { once: true }) : fn());
  const phone = () => matchMedia('(max-width: 859px)').matches;
  const emit = (name, detail) => document.dispatchEvent(new CustomEvent(name, { detail }));

  ready(() => {
    /* Header: a firmer bar once the page has scrolled */
    const header = document.querySelector('[data-dx-header]');
    const pageWrap = document.querySelector('.page-wrapper');
    const scrolled = () => (pageWrap && getComputedStyle(root).overflowY === 'hidden' ? pageWrap.scrollTop : scrollY);
    if (header) {
      const onScroll = () => header.classList.toggle('is-scrolled', scrolled() > 8);
      document.addEventListener('scroll', onScroll, { capture: true, passive: true });
      onScroll();
    }

    /* Current page in the menu (header and tab bar are marked on the server) */
    const here = location.pathname.replace(/\/$/, '') || '/';
    document.querySelectorAll('.dx-menu-cols a, .dx-footer-cols a').forEach((a) => {
      const u = new URL(a.href, location.href);
      if ((u.pathname.replace(/\/$/, '') || '/') === here && !u.search) a.setAttribute('aria-current', 'page');
    });

    /* Tab bar ink sits under the current tab (the motion layer animates it) */
    const tabbar = document.querySelector('[data-dx-tabbar]');
    const placeInk = () => {
      if (!tabbar) return;
      const ink = tabbar.querySelector('.dx-tab-ink');
      const on = tabbar.querySelector('.dx-tab[aria-expanded="true"]') || tabbar.querySelector('.dx-tab[aria-current="page"]');
      if (!ink || !on || !phone()) { if (ink) ink.hidden = true; root.classList.remove('dx-tabink'); return; }
      ink.hidden = false;
      ink.style.left = `${on.offsetLeft + 4}px`;
      ink.style.width = `${on.offsetWidth - 8}px`;
      root.classList.add('dx-tabink');
    };
    placeInk();
    addEventListener('resize', placeInk, { passive: true });

    /* Segmented sub-navigation: keep the current item in view */
    document.querySelectorAll('.dx-subnav-row').forEach((row) => {
      const on = row.querySelector('[aria-current="page"]');
      if (on && row.scrollWidth > row.clientWidth) row.scrollLeft = Math.max(0, on.offsetLeft - 24);
    });

    /* Menu: dropdown on desktop, bottom sheet on phones, opened by the header button or "More" */
    const menu = document.querySelector('[data-dx-menu]');
    const more = document.querySelector('[data-dx-more]');
    if (menu) {
      const summary = menu.querySelector('summary');
      let opener = null;
      const sync = () => {
        summary.setAttribute('aria-label', menu.open ? 'Close the full menu' : 'Open the full menu');
        if (more) more.setAttribute('aria-expanded', String(menu.open));
        root.classList.toggle('dx-sheet-open', menu.open && phone());
        root.classList.toggle('dx-menu-open', menu.open);
        placeInk();
        emit('dx:menu', { open: menu.open });
      };
      const close = (focusBack = true) => {
        if (!menu.open) return;
        if (window.DXMotion && window.DXMotion.closeMenu) window.DXMotion.closeMenu(() => { menu.open = false; });
        else menu.open = false;
        if (focusBack) (opener || summary).focus({ preventScroll: true });
      };
      menu.addEventListener('toggle', () => {
        sync();
        if (menu.open) {
          if (!opener) opener = summary;
          const first = phone() ? menu.querySelector('.dx-sheet-close') : menu.querySelector('#dx-search-q');
          if (first && !phone()) setTimeout(() => first.focus({ preventScroll: true }), 60);
        } else opener = null;
      });
      summary.addEventListener('click', (e) => {
        if (menu.open) { e.preventDefault(); close(false); }
        else opener = summary;
      });
      if (more) more.addEventListener('click', (e) => {
        e.stopPropagation();
        if (menu.open) close();
        else { opener = more; menu.open = true; }
      });
      menu.querySelectorAll('[data-dx-close]').forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); close(); }));
      document.addEventListener('click', (e) => { if (menu.open && !menu.contains(e.target) && !(more && more.contains(e.target))) close(false); });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && menu.open) close(); });
      menu.querySelectorAll('.dx-menu-cols a').forEach((a) => a.addEventListener('click', () => { menu.open = false; }));
      sync();
    }

    /* Install prompt */
    const install = document.querySelector('[data-dx-install]');
    const standalone = matchMedia('(display-mode: standalone)').matches || navigator.standalone === true;
    if (install && !standalone) {
      const ios = /iphone|ipad|ipod/i.test(navigator.userAgent) && !/crios|fxios/i.test(navigator.userAgent);
      if (ios) { install.hidden = false; install.querySelector('.dx-install-ios').hidden = false; }
      let deferred = null;
      addEventListener('beforeinstallprompt', (e) => {
        e.preventDefault(); deferred = e;
        install.hidden = false; install.querySelector('[data-dx-install-btn]').hidden = false;
      });
      install.querySelector('[data-dx-install-btn]').addEventListener('click', async () => {
        if (!deferred) return;
        deferred.prompt();
        await deferred.userChoice.catch(() => null);
        deferred = null; install.hidden = true;
      });
    }

    /* Paywall: the chosen plan names the action */
    document.querySelectorAll('[data-dx-paywall]').forEach((pw) => {
      const cta = pw.querySelector('[data-dx-pw-cta]');
      const sync = () => {
        const bill = pw.querySelector('.dx-pw-billing input:checked');
        const yearly = !!bill && bill.value === 'yearly';
        pw.dataset.billing = yearly ? 'yearly' : 'monthly';
        const on = pw.querySelector('.dx-plans input[type=radio]:checked');
        pw.querySelectorAll('.dx-plan').forEach((p) => p.classList.toggle('is-on', !!on && p.contains(on)));
        if (on && cta) {
          cta.href = (yearly && on.dataset.hrefY) || on.dataset.href;
          cta.textContent = (yearly && on.dataset.ctaY) || on.dataset.cta;
        }
        emit('dx:plan', { root: pw, plan: on && on.value });
      };
      pw.querySelectorAll('input[type=radio]').forEach((r) => r.addEventListener('change', sync));
      sync();
    });

    /* Locked lessons open the paywall as a sheet instead of leaving the lesson */
    const pwSheet = document.getElementById('dvs-paywall-sheet');
    if (pwSheet && typeof pwSheet.showModal === 'function') {
      let opener = null;
      document.addEventListener('click', (e) => {
        const a = e.target.closest('main a[href^="/pages/membership"]');
        if (!a || a.closest('.dx-home, .dx-paywall, [data-dx-no-sheet]')) return;
        if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        e.preventDefault();
        opener = a;
        const want = (a.getAttribute('href').split('#')[1] || '').toLowerCase();
        const pick = pwSheet.querySelector(`input[value="${want === 'plus' ? 'plus' : 'basic'}"]`);
        if (pick && !pick.checked) { pick.checked = true; pick.dispatchEvent(new Event('change', { bubbles: true })); }
        pwSheet.showModal();
        root.classList.add('dx-sheet-open');
        emit('dx:sheet', { el: pwSheet, open: true });
        pwSheet.querySelector('[data-dx-pw-close]')?.focus();
      });
      pwSheet.querySelector('[data-dx-pw-close]')?.addEventListener('click', () => pwSheet.close());
      pwSheet.addEventListener('click', (e) => { if (e.target === pwSheet) pwSheet.close(); });
      pwSheet.addEventListener('close', () => { root.classList.remove('dx-sheet-open'); opener?.focus({ preventScroll: true }); });
    }

    /* Rank journey: the current and next rank, the rest on request */
    const collapseRanks = () => {
      document.querySelectorAll('.dv-rank-gallery:not([data-dx-ranks])').forEach((g) => {
        const cards = [...g.querySelectorAll(':scope > .dv-rank-card')];
        const cur = g.querySelector(':scope > .dv-rank-card-current');
        if (cards.length < 4 || !cur) return;
        g.dataset.dxRanks = '1';
        cur.nextElementSibling?.classList.add('dvs-next-rank');
        g.classList.add('dvs-collapsed');
        const btn = document.createElement('button');
        btn.type = 'button'; btn.className = 'dx-rank-toggle';
        btn.setAttribute('aria-expanded', 'false');
        btn.textContent = `See all ${cards.length} ranks`;
        btn.addEventListener('click', () => {
          const open = g.classList.toggle('dvs-collapsed') === false;
          btn.setAttribute('aria-expanded', String(open));
          btn.textContent = open ? 'Show fewer ranks' : `See all ${cards.length} ranks`;
        });
        g.after(btn);
      });
    };
    const labelCase = { RANK: 'Rank', LEVEL: 'Level', XP: 'XP', COMPLETED: 'Completed' };
    const fixLabels = () => document.querySelectorAll('.skills-summary > div > span:first-child').forEach((s) => {
      const t = s.textContent.trim(); if (labelCase[t] && labelCase[t] !== t) s.textContent = labelCase[t];
    });
    collapseRanks(); fixLabels();
    const main = document.querySelector('main');
    if (main) new MutationObserver(() => { collapseRanks(); fixLabels(); }).observe(main, { childList: true, subtree: true });

    /* Cookie preferences open Shopify's own consent settings */
    document.querySelectorAll('[data-dx-cookie-prefs]').forEach((btn) => btn.addEventListener('click', () => {
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') window.privacyBanner.showPreferences();
      else location.href = '/pages/cookie-policy';
    }));

    /* The live scorecard: tap the clean strikes, compare with last visit */
    document.querySelectorAll('[data-dx-scorecard]').forEach((card) => {
      const last = Number(card.dataset.last || 0);
      const out = card.querySelector('[data-dx-today]');
      const note = card.querySelector('[data-dx-note]');
      const balls = [...card.querySelectorAll('[data-dx-attempt]')];
      const fmt = new Intl.NumberFormat(document.documentElement.lang || undefined);
      const update = (ball) => {
        const n = balls.filter((b) => b.getAttribute('aria-pressed') === 'true').length;
        out.textContent = fmt.format(n);
        card.dataset.count = String(n);
        const diff = n - last;
        note.textContent =
          n === 0 ? 'Nothing marked yet. Every attempt counts, including the ones you would rather forget.'
          : diff > 0 ? `${diff} better than last visit. Same setup next time before you make the drill harder.`
          : diff === 0 ? 'Level with last visit. That is useful too: repeat it before changing anything.'
          : `${-diff} below last visit. One score is one data point. Repeat the same test.`;
        emit('dx:attempt', { card, ball, clean: ball.getAttribute('aria-pressed') === 'true', count: n, index: balls.indexOf(ball) });
      };
      balls.forEach((b) => b.addEventListener('click', () => {
        b.setAttribute('aria-pressed', String(b.getAttribute('aria-pressed') !== 'true'));
        update(b);
      }));
      card.querySelector('[data-dx-reset]')?.addEventListener('click', () => {
        balls.forEach((b) => b.setAttribute('aria-pressed', 'false'));
        out.textContent = fmt.format(0); card.dataset.count = '0';
        note.textContent = 'Fresh card. Tap the attempts you strike cleanly.';
        emit('dx:attempt-reset', { card });
      });
    });

    /* Plan picker on the home page points the button at the right plan */
    document.querySelectorAll('[data-dx-pricing]').forEach((block) => {
      const cta = block.querySelector('[data-dx-plan-cta]');
      const panels = block.querySelectorAll('[data-dx-plan-panel]');
      const inputs = block.querySelectorAll('input[name="dx-plan"]');
      const sync = () => {
        const on = block.querySelector('input[name="dx-plan"]:checked');
        if (!on) return;
        panels.forEach((p) => { p.hidden = p.dataset.dxPlanPanel !== on.value; });
        if (cta) { cta.href = on.dataset.href; cta.textContent = on.dataset.cta; }
        emit('dx:plan', { root: block, plan: on.value });
      };
      inputs.forEach((i) => i.addEventListener('change', sync));
      sync();
    });

    /* On-page jump links follow the reader */
    document.querySelectorAll('[data-dx-jump]').forEach((bar) => {
      const links = [...bar.querySelectorAll('a[href^="#"]')];
      const targets = links.map((a) => document.getElementById(a.getAttribute('href').slice(1))).filter(Boolean);
      if (!targets.length || !('IntersectionObserver' in window)) return;
      const row = bar.querySelector('.dx-jump-row') || bar;
      const io = new IntersectionObserver((es) => es.forEach((e) => {
        if (!e.isIntersecting) return;
        links.forEach((a) => {
          const on = a.getAttribute('href') === `#${e.target.id}`;
          a.classList.toggle('is-here', on);
          if (on) {
            a.setAttribute('aria-current', 'location');
            if (row.scrollWidth > row.clientWidth) row.scrollTo({ left: Math.max(0, a.offsetLeft - 24), behavior: 'smooth' });
            emit('dx:jump', { bar, link: a });
          } else a.removeAttribute('aria-current');
        });
      }), { rootMargin: '-40% 0px -55% 0px' });
      targets.forEach((t) => io.observe(t));
    });

    /* Back to the top */
    document.querySelectorAll('[data-dx-totop]').forEach((a) => a.addEventListener('click', (e) => {
      e.preventDefault();
      if (window.DXMotion && window.DXMotion.scrollTo) window.DXMotion.scrollTo(0);
      else (pageWrap && getComputedStyle(root).overflowY === 'hidden' ? pageWrap : window).scrollTo({ top: 0, behavior: 'smooth' });
      setTimeout(() => document.getElementById('MainContent')?.focus({ preventScroll: true }), 600);
    }));

    root.classList.add('dx-ready');
  });
})();
